var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change"},[_vm._v(_vm._s(_vm.change.info.new ? 'Задача закрыта' : 'Задача открыта'))])}
var staticRenderFns = []

export { render, staticRenderFns }